import { Controller, useFormContext } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
import __ from "src/utils/Translations";
import { conditionTypesFilterOptions } from "src/Pages/Company/Pending/PendingBenefits/const";

export const StatusAutocomplete = ({
  name,
  label,
}: {
  name: string;
  label: string;
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, ref, value },
        fieldState: { invalid, error },
      }) => (
        <Autocomplete
          options={conditionTypesFilterOptions}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, selectedValue) =>
            String(option.value) === String(selectedValue.value)
          }
          value={
            (value &&
              conditionTypesFilterOptions.find(
                (row) => String(row.value) === String(value)
              )) ??
            null
          }
          onChange={(_event, newValue) => {
            onChange(newValue?.value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              inputRef={ref}
              error={invalid}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
};
